<template>
  <div id="note-wrap">
    <div v-if="!note">
      리뷰가 없습니다~
    </div>
    <div v-html="note" id="note-content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      note: null,
      note_modified_ts: null,
    }
  },

  computed: {
    proj_id() {
      return parseInt(this.$route.params.id)
    }
  },

  watch: {
    proj_id: {
      async handler(val) {
        if (!!val) {
          await this.getProjNoteInfo()
        }
      },
      immediate: true,
    }
  },

  methods: {
    async getProjNoteInfo() {
      try {
        await this.$store.dispatch('watching/getProjNoteInfo', this.proj_id)
      } finally {
        let note_info = this.$store.getters['watching/proj_note_info']
        this.note_modified_ts = note_info.note_modified_ts
        this.note = this.parseNote(note_info.note)
      }
    },

    parseNote(note) {
      if (note == null) { return null }
      else {
        let html_txt = JSON.parse(note).data
        return html_txt == '<p></p>' ? null : html_txt
      }
    },
  },
}
</script>

<style scoped>
  
  #note-wrap {
    height: 100%;
    padding: 20px;
    overflow: auto;
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/project-watching/Note.vue